import React from "react";

import { Button, Stack } from "@mui/material";

interface Props {
  onCancel: () => void;
  onSubmit: () => void | Promise<void>;
  isLoading: boolean;
}

export const Footer: React.FC<Props> = ({ onCancel, onSubmit, isLoading }) => {
  return (
    <Stack
      sx={{ p: "24px", gap: "10px", borderTop: "1px solid #dae0e2" }}
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
    >
      <Button disabled={isLoading} onClick={onCancel}>
        Cancel
      </Button>
      <Button disabled={isLoading} type="submit" variant="contained" onClick={onSubmit}>
        Save
      </Button>
    </Stack>
  );
};
